// IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid))
// Высота строк грида — переключатель «Рядки: Компактні / Високі» (общий для вкладки «Heatmap (grid)», AttrHeatmapGrid.vue, и панели видов ячеек REPORT2, AttrGrid.vue):
// — «Компактні» — штатная высота строк грида (ничего не меняется); «Високі» — GRID_TALL_ROW_H (как строка основной теплокарты: 32 px содержимого + 2 px рамок),
//   текст ячеек данных и заголовков строк — по центру по вертикали (CSS line-height по классу корня, не flex: text-align и многоточие сохраняются);
// — выбор вида ячеек с кругами (любой, кроме «Числа») один раз включает «Високі», если пользователь сам не трогал переключатель; возврат к «Числа» высоту не меняет.
// Состояние — в памяти виджета / вкладки, в запись не пишется. Выключатель механизма в гриде REPORT2 — fe.ux.gridRowsSwitch (дефолт ВКЛ, §8).
// Чистые функции (без Vue и DOM) — tests/unit/gridRows.test.mjs
export const GRID_ROWS_FLAG = 'fe.ux.gridRowsSwitch'
export const GRID_ROWS = Object.freeze([{ key: 'compact', title: 'Compact' }, { key: 'tall', title: 'Tall' }])
export const GRID_TALL_ROW_H = 34
export const GRID_ROWS_NUMBERS = 'numbers'

// режим: только 'tall' — высокие, всё прочее — компактные
export const gridRows_norm = (rows) => (rows === 'tall' ? 'tall' : 'compact')

// чтение флага (нет читателя / ошибка — ВКЛ)
export function gridRows_flagOn(setting) {
    try { return typeof setting === 'function' ? setting(GRID_ROWS_FLAG, true) !== false : true } catch (e) { return true }
}

// режим после выбора вида ячеек: вид с кругами (непустой, не «numbers») при нетронутом переключателе — 'tall'; иначе — текущий
export function gridRows_afterView(view, rows, userTouched) {
    const cur = gridRows_norm(rows)
    const circles = !!view && view !== GRID_ROWS_NUMBERS
    return circles && !userTouched ? 'tall' : cur
}

// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 — «Рядки» натиснута типово: високі рядки в звіті з видами комірок)
// режим при первом открытии: состояния в памяти виджета ещё нет (rows не задан) и переключатель не трогали — 'tall', если бэк пометил кнопки видов
// rows_default: 'tall' (cell_views.rows_tall_default) и выключатель fe.ux.gridRowsTallDefault не снят; иначе — null (ничего не менять)
export const GRID_ROWS_TALL_DEFAULT_FLAG = 'fe.ux.gridRowsTallDefault'
export function gridRows_initial(rows, touched, buttons, setting) {
    if ((rows !== undefined && rows !== null && rows !== '') || touched) return null
    try { if (typeof setting === 'function' && setting(GRID_ROWS_TALL_DEFAULT_FLAG, true) === false) return null } catch (e) { /* ВКЛ */ }
    return (Array.isArray(buttons) ? buttons : []).some(b => b && b.rows_default === 'tall') ? 'tall' : null
}

// IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid)): «Високі» один раз — только когда вид сменил ПОЛЬЗОВАТЕЛЬ (клик по кнопке панели, меню / команда: счётчик userSeq растёт в mainStore.cellView_toggle);
// открытие отчёта с видом по умолчанию и перестроение грида лишь запоминают вид, высоту не трогают. st — { view, rows, touched, seq } (seq — последний учтённый userSeq) → новое st
export function gridRows_syncState(st, view, userSeq) {
    const s = { view: st ? st.view : undefined, rows: gridRows_norm(st && st.rows), touched: !!(st && st.touched), seq: Number(st && st.seq) || 0 }
    const seq = Number(userSeq) || 0
    if (s.view === view && s.seq === seq) return s
    const byUser = seq !== s.seq && s.view !== view
    return { view, rows: byUser ? gridRows_afterView(view, s.rows, s.touched) : s.rows, touched: s.touched, seq }
}

// желаемая высота строки: tall — max(штатная, GRID_TALL_ROW_H), compact — штатная (h0); нет штатной — 0 (ничего не менять)
export function gridRows_height(rows, h0) {
    const base = Number(h0) > 0 ? Number(h0) : 0
    if (!base) return 0
    return gridRows_norm(rows) === 'tall' ? Math.max(base, GRID_TALL_ROW_H) : base
}

// прокрутка по вертикали при смене высоты — та же верхняя строка (масштаб по высоте)
export function gridRows_scrollY(y, hOld, hNew) {
    const a = Number(hOld), b = Number(hNew), v = Number(y)
    if (!Number.isFinite(v) || !(a > 0) || !(b > 0)) return Number.isFinite(v) ? v : 0
    return Math.round(v * b / a)
}

// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p197 перемикач «Рядки» — зберегти виділення і якір прокрутки на центрі виділеної клітинки)
// Якорь прокрутки при смене высоты строк (флаг fe.ux.gridRowsToggleAnchor, дефолт ВКЛ, §8; ВЫКЛ — прежний масштаб gridRows_scrollY):
// — выделенная ячейка видна (её строка в видимом диапазоне) — центр её строки остаётся на той же экранной высоте;
// — выделения нет или оно за экраном — верх первой видимой строки остаётся на месте (начало грида не уезжает).
export const GRID_ROWS_ANCHOR_FLAG = 'fe.ux.gridRowsToggleAnchor'

export function gridRows_anchorFlagOn(setting) {
    try { return typeof setting === 'function' ? setting(GRID_ROWS_ANCHOR_FLAG, true) !== false : true } catch (e) { return true }
}

// выбор якоря: sel — { row, row2? } выделения (null — нет), view — { row, row2 } видимых строк → { row, frac } (frac — доля высоты строки), null — якоря нет
const num_ = (o, k) => (o && o[k] != null ? Number(o[k]) : NaN)
export function gridRows_anchorPick(sel, view) {
    const v0 = num_(view, 'row'), v1 = num_(view, 'row2')
    const r = num_(sel, 'row')
    if (Number.isInteger(r) && r >= 0 && Number.isFinite(v0) && Number.isFinite(v1) && r >= v0 && r <= v1) return { row: r, frac: 0.5 }
    if (Number.isInteger(v0) && v0 >= 0) return { row: v0, frac: 0 }
    return null
}

// новая прокрутка по вертикали: y — scrollPosition.y до (≤ 0); a0 / a1 — { pos, size } строки-якоря до / после смены высоты; frac — точка якоря в строке (0 — верх, 0.5 — центр);
// maxScroll — полная высота минус видимая после смены (нет — без нижней границы). Экранное смещение точки якоря y + pos + frac·size сохраняется.
export function gridRows_anchorScrollY(y, a0, a1, frac = 0.5, maxScroll) {
    const v = Number(y)
    if (!Number.isFinite(v)) return 0
    const hdr_ = (o) => { const h = num_(o, 'hdr'); return Number.isFinite(h) ? h : 0 }   // IE 2026 11 02 / ODOO-350449 (сводна перевірка main на dev02: p199 — якір при scroll 0, повернення висоти рядків, перемалювання колонок «Всього», Alt-підказка «Рядки»): hdr — высота шапки колонок над строками (верх панели ячеек); при прокрутке от 0 появляется sticky-полоса группы (+1 строка шапки) — точка якоря на экране учитывает её
    const p0 = num_(a0, 'pos') + hdr_(a0), s0 = num_(a0, 'size'), p1 = num_(a1, 'pos') + hdr_(a1), s1 = num_(a1, 'size')
    if (![p0, s0, p1, s1].every(Number.isFinite)) return v
    const f = Number.isFinite(Number(frac)) ? Math.min(1, Math.max(0, Number(frac))) : 0.5
    let ny = v + (p0 + f * s0) - (p1 + f * s1)
    const m = Number(maxScroll)
    if (maxScroll != null && Number.isFinite(m) && m >= 0 && ny < -m) ny = -m
    if (ny > 0) ny = 0
    return Math.round(ny)
}

// IE 2026 11 02 / ODOO-350449 (сводна перевірка main на dev02: p199 — якір при scroll 0, повернення висоти рядків, перемалювання колонок «Всього», Alt-підказка «Рядки»)
// Своя высота строки (row.height, не null) при смене штатной высоты hOld → hNew: начало секции дерева / группы — штатная + зазор (formatItem / autoSizeRows:
// defaultSize + breakTop, breakTop ∈ {0, 10}) — пересчитывается от новой штатной (hNew + зазор); высота из настройки строки лэйаута (rowH > 0) и прочие (ячейки с чипсами,
// перенос) — без изменений. Преобразование обратимо: компактні → високі → компактні возвращает исходную высоту (27 → 44 → 27 при 17 / 34), без памяти по строкам.
// null — высоты своей нет (строка штатная) или менять не нужно
export const GRID_ROWS_GAPS = Object.freeze([0, 10])
export function gridRows_rowHeight(h, hOld, hNew, rowH = 0, gaps = GRID_ROWS_GAPS) {
    const v = Number(h), a = Number(hOld), b = Number(hNew)
    if (h == null || !Number.isFinite(v) || !(a > 0) || !(b > 0) || a === b) return null
    if (Number(rowH) > 0) return null
    const d = v - a
    if (!(gaps || []).some(g => Number(g) === d)) return null
    return b + d
}
